module.exports = {"450324100":"全州镇","450324101":"黄沙河镇","450324102":"庙头镇","450324103":"文桥镇","450324104":"大西江镇","450324105":"龙水镇","450324106":"才湾镇","450324107":"绍水镇","450324108":"石塘镇","450324109":"咸水镇","450324110":"凤凰镇","450324111":"安和镇","450324112":"两河镇","450324113":"枧塘镇","450324114":"永岁镇","450324204":"蕉江瑶族乡","450324207":"白宝乡","450324208":"东山瑶族乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/450324.json
// module id = 2100
// module chunks = 0